module.exports = __webpack_public_path__ + "img/pixing_xc7.2d772957.jpg";